import React, { Component } from 'react';
import { DatePicker, message,Select } from 'antd';
import moment from 'moment-timezone';
// import { map } from 'lodash';
import Loader from '../../../../Common/Component/Loader';
import { errorHandle } from '../../../../Common/errorHandle';
import { DownOutlined } from '@ant-design/icons';
const { Option } = Select;

moment.updateLocale("en", { week: { dow: 1 } });

class Aside extends Component {
  state = {
    last_step: false,
    weekly_avg_data: {},
    weekly_service_statistics: {},
    earch_param: '',
    start_date: null,
    end_date: null,
    field_staff: {},
    loader: false,
    weekDate: '',
    is_week_setup: false,
    is_res_sub_checked_all: true,
    is_commercial_sub_checked_all: true,
    is_pws_sub_checked_all: true,
    selected_franchise : ''
  }


  componentDidMount = () => {
    var weekStart = moment().clone().startOf('isoWeek').format('YYYY-MM-DD')+ 'T00:00:00';
    var weekEnd = moment().clone().endOf('isoWeek').format('YYYY-MM-DD')+ 'T23:59:59';
   

    // const dashboard_value = this.props?.history?.location?.state?.query?.value;
    const user = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser"))
      : "";
    const default_franchise_uuid = user?.user?.associated_field_offices[0].uuid;
    this.setState({
      start_date: weekStart,
      end_date: weekEnd,
      selected_franchise : default_franchise_uuid
    });

    //Get Weeekly Avg
    this.props.getWeeklyAvgData({ 
      start_date: weekStart, 
      end_date: weekEnd,
      field_office__uuid : default_franchise_uuid
    });
    //Service statistics
    this.props.getServiceStatistics({
      start_date: weekStart, 
      end_date: weekEnd,
      field_office__uuid : default_franchise_uuid
    })

    let start = moment(weekStart).format('DD');
    let end = moment(weekEnd).format('DD');
    let string = start + "-" + end;
    this.setState({
      weekDate: string
    });


    //Get Staff list
    this.props.getFieldOfficeStaff({ 
      start_date: moment(weekStart).format('YYYY-MM-DD'),
      field_office__uuid : default_franchise_uuid,
      ordering:'user__first_name'
    });
    
  }

  UNSAFE_componentWillReceiveProps = (props) => {

    if (props.current === 2) {
      this.setState({
        last_step: true,
        technicians : this.props.technician_details
      })
    }
    else {
      this.setState({
        last_step: false
      })
    }


    if (Object.keys(props.WeeklyAvgData.data).length > 0 && props.WeeklyAvgData.data !== this.props.WeeklyAvgData.data) {
      let res_sub_services = [], commercial_sub_servcies = [], pws_sub_services = []
      res_sub_services.push(
        {
          "display_name": "Twice-Weekly Service",
          "name": "twice_weekly",
          "value": props.WeeklyAvgData.data?.residential_cleaning?.twice_weekly,
          "is_checked": true,
          "id": 1,
        },
        {
          "display_name": "Weekly Service",
          "name": "weekly",
          "value": props.WeeklyAvgData.data?.residential_cleaning?.weekly,
          "is_checked": true,
          "id": 2,
        },
        {
          "display_name": "Every Other Week",
          "name": "other_week",
          "value": props.WeeklyAvgData.data?.residential_cleaning?.every_other_week,
          "is_checked": true,
          "id": 3,
        },
        {
          "display_name": "Monthly",
          "name": "bi_monthly",
          "value": props.WeeklyAvgData.data?.residential_cleaning?.monthly,
          "is_checked": true,
          "id": 4,
        },
        {
          "display_name": "One Time Cleans",
          "name": "once",
          "value": props.WeeklyAvgData.data?.residential_cleaning?.one_time,
          "is_checked": true,
          "id": 5,
        })


      commercial_sub_servcies.push(
        {
          "display_name": "Pet Waste Station Cleaning ",
          "name": "pet_waste_station",
          "value": props.WeeklyAvgData.data?.commercial_cleaning?.pet_wet_station_cleaning,
          "is_checked": true,
          "id": 6,
        },
        {
          "display_name": "Common Area Cleaning",
          "name": "common_area_cleaning",
          "value": props.WeeklyAvgData.data?.commercial_cleaning?.common_area_cleaning,
          "is_checked": true,
          "id": 7,
        },

        {
          "display_name": "Installation Repair ",
          "name": "install",
          "value": props.WeeklyAvgData.data?.commercial_cleaning?.installation_repairs,
          "is_checked": true,
          "id": 8,
        })

      pws_sub_services.push({
        "display_name": " Pet Waste Station Installations",
        "name": "pet_waste_station_install",
        "value": props.WeeklyAvgData.data?.pws_installation,
        "is_checked": true,
        "id": 9,


      })
      this.setState({
        res_sub_services,
        commercial_sub_servcies,
        pws_sub_services
      })
    }
    if (Object.keys(props.WeeklyAvgData.errors).length > 0 && props.WeeklyAvgData.errors !== this.props.WeeklyAvgData.errors) {
      //Display error message
      errorHandle(props?.WeeklyAvgData?.errors);
    }

    if (Object.keys(props.ServiceStatistics.data).length > 0 && props.ServiceStatistics.data !== this.props.ServiceStatistics.data) {
      // console.log("Check::::::>", props?.ServiceStatistics?.data?.data)
      this.setState({
        loader: false,
        weekly_service_statistics: props?.ServiceStatistics?.data?.data
      })
    }

    if (Object.keys(props.ServiceStatistics.errors).length > 0 && props.ServiceStatistics.errors !== this.props.ServiceStatistics.errors) {
      //Display error message
      this.setState({
        loader: false
      });
      errorHandle(props?.ServiceStatistics?.errors);
    }

    //get Staff List
    if (Object.keys(props.FieldStaff.data).length > 0 && props.FieldStaff.data !== this.props.FieldStaff.data) {
      this.setState({
        loader: false,
        field_staff: props.FieldStaff.data.results
      })
    }

    if (Object.keys(props.FieldStaff.errors).length > 0 && props.FieldStaff.errors !== this.props.FieldStaff.errors) {
      this.setState({
        loader: false,
      });
      errorHandle(props?.FieldStaff?.errors);
    }


    // message.destroy();
    //get Intial Service
    if (Object.keys(props.IntialService.data).length > 0 && props.IntialService.data !== this.props.IntialService.data) {
      this.setState({
        loader: false,
      })
    }

    if (Object.keys(props.IntialService.errors).length > 0 && props.IntialService.errors !== this.props.IntialService.errors) {
      this.setState({
        loader: false,
      });
      errorHandle(props?.IntialService?.errors);
    }

    //get Residentail Service
    if (Object.keys(props.ResidentailService.data).length > 0 && props.ResidentailService.data !== this.props.ResidentailService.data) {
      this.setState({
        loader: false,
      })
    }

    if (Object.keys(props.ResidentailService.errors).length > 0 && props.ResidentailService.errors !== this.props.ResidentailService.errors) {
      this.setState({
        loader: false,
      });
      errorHandle(props?.ResidentailService?.errors);
    }

    //get Commercial Service
    if (Object.keys(props.CommercialService.data).length > 0 && props.CommercialService.data !== this.props.CommercialService.data) {
      this.setState({
        loader: false,
      })
    }

    if (Object.keys(props.CommercialService.errors).length > 0 && props.CommercialService.errors !== this.props.CommercialService.errors) {
      this.setState({
        loader: false,
      });
      errorHandle(props?.CommercialService?.errors);
    }

    //get Install Service
    if (Object.keys(props.InstallService.data).length > 0 && props.InstallService.data !== this.props.InstallService.data) {
      this.setState({
        loader: false,
      })
    }

    if (Object.keys(props.InstallService.errors).length > 0 && props.InstallService.errors !== this.props.InstallService.errors) {
      this.setState({
        loader: false,
      });
      errorHandle(props?.InstallService?.errors);
    }

  }


  //Get Service ORder
  getServiceOrder = (start, end) => {
    //Intial Clean
    this.props.getServiceAllocationIntialClean({
      limit: 15,
      offset: 0,
      service_skill_type__skill_name__in: 'residential_init_clean',
      scheduled_time__gte: start,
      scheduled_time__lte: end,
      status: "tentative",
      ordering: 'scheduled_time',
    });

    //Residentail Clean
    this.props.getServiceAllocationResidentail({
      limit: 15,
      offset: 0,
      service_skill_type__skill_name__in: 'residential_regular',
      scheduled_time__gte: start,
      scheduled_time__lte: end,
      status: "tentative",
      ordering: 'scheduled_time',
    })

    //Commercial 
    this.props.getServiceAllocationCommercail({
      limit: 15,
      offset: 0,
      service_skill_type__skill_name__in: 'common_area_cleaning,pet_waste_station,install_repair,pet_waste_station_install',
      scheduled_time__gte: start,
      scheduled_time__lte: end,
      status: "tentative",
      ordering: 'scheduled_time',
    })

    //Install
    this.props.getServiceAllocationInstall({
      limit: 15,
      offset: 0,
      service_skill_type__skill_name__in: 'pet_waste_station_install',
      scheduled_time__gte: start,
      scheduled_time__lte: end,
      status: "tentative",
      ordering: 'scheduled_time',
    })
    this.setState({
      loader: true
    })
  }

  handleResidentialService = (e) => {
    if (e.target.name === 'twice-weekly') {
      this.props.residentailServices(e.target.value)
    }
  }

  handleCheckedResidentialServices = (e) => {
    let itemName = e.target.name;
    let checked = e.target.checked;
    this.setState(prevState => {
      let { res_sub_services, is_res_sub_checked_all } = prevState;
      if (itemName === "check_all") {
        is_res_sub_checked_all = checked;
        res_sub_services = res_sub_services.map(item => ({ ...item, is_checked: checked }));
        this.props.handleServicesTypes(res_sub_services)

      } else {
        res_sub_services = res_sub_services.map(item =>
          item?.name === itemName ? { ...item, is_checked: checked } : item
        );
        is_res_sub_checked_all = res_sub_services.every(item => item.is_checked);
        this.props.handleServicesTypes(res_sub_services)
      }
      return { res_sub_services, is_res_sub_checked_all };
    });
  }


  handleCheckedCommercialServices = (e) => {
    let itemName = e.target.name;
    let checked = e.target.checked;
    this.setState(prevState => {
      let { commercial_sub_servcies, is_commercial_sub_checked_all } = prevState;
      if (itemName === "check_all") {
        is_commercial_sub_checked_all = checked;
        commercial_sub_servcies = commercial_sub_servcies.map(item => ({ ...item, is_checked: checked }));
        this.props.handleServicesTypes(commercial_sub_servcies)

      } else {
        commercial_sub_servcies = commercial_sub_servcies.map(item =>
          item?.name === itemName ? { ...item, is_checked: checked } : item
        );
        is_commercial_sub_checked_all = commercial_sub_servcies.every(item => item.is_checked);
        this.props.handleServicesTypes(commercial_sub_servcies)

      }
      return { commercial_sub_servcies, is_commercial_sub_checked_all };
    });
  }

  handleCheckedPWsServices = (e) => {
    let itemName = e.target.name;
    let checked = e.target.checked;
    this.setState(prevState => {
      let { pws_sub_services, is_pws_sub_checked_all } = prevState;
      if (itemName === "check_all") {
        is_pws_sub_checked_all = checked;
        pws_sub_services = pws_sub_services.map(item => ({ ...item, is_checked: checked }));
        this.props.handleServicesTypes(pws_sub_services)

      } else {
        pws_sub_services = pws_sub_services.map(item =>
          item?.name === itemName ? { ...item, is_checked: checked } : item
        );
        is_pws_sub_checked_all = pws_sub_services.every(item => item.is_checked);
        this.props.handleServicesTypes(pws_sub_services)
      }
      return { pws_sub_services, is_pws_sub_checked_all };
    });
  }

  render() {
    // console.log("Technician Details : ",this.props.technician_details)
    let { last_step, weekly_service_statistics, loader, start_date } = this.state;
    let { current } = this.props;

    return (
      <aside className="laside fo-side d-flex flex-column justify-content-between">
        <div className="w-100">
          <h3>Field Ops 12</h3>
          <div className="form-group mb-10">
            <DatePicker
              picker="week"
              disabled={current === 0 ? false : true}
              defaultValue={moment()}
              inputReadOnly
              style={{ 'width': '100%' }}
              onChange={(e) => {
                if (e) {
                  this.setState({ loader: true, start_date: moment(e).startOf('week').format('YYYY-MM-DD'), end_date: moment(e).endOf('week').format('YYYY-MM-DD') });
                  this.props.handleWeekDate(moment(e).startOf('week').format('YYYY-MM-DD'));
                  this.props.getWeeklyAvgData({ 
                    start_date : moment(e).startOf('week').format('YYYY-MM-DD') + 'T00:00:00',
                    end_date : moment(e).endOf('week').format('YYYY-MM-DD') + 'T23:59:59',
                    field_office__uuid : this.state.selected_franchise
                  });
                  //Service statistics
                  // this.props.getServiceStatistics({ start_date: moment(e).startOf('week').format('YYYY-MM-DD'), end_date: moment(e).endOf('week').format('YYYY-MM-DD') })
                  this.setState({
                    // search_param: '',
                    start_date: moment(e).startOf('week').format('YYYY-MM-DD'),
                    end_date: moment(e).endOf('week').format('YYYY-MM-DD')
                  })
                  //Get Service Order
                  // this.getServiceOrder(moment(e).startOf('week').format('YYYY-MM-DDT00:00:00'), moment(e).endOf('week').format('YYYY-MM-DDT23:59:59'));
                  this.props.getFieldOfficeStaff({ 
                    start_date: moment(e).startOf('week').format('YYYY-MM-DD'),
                    field_office__uuid : this.props.selected_franchise,
                    ordering:'user__first_name'
                  });

                }
                else {
                  this.setState({
                    loader: true, start_date: moment(moment().day(1)).format('YYYY-MM-DD'),
                    end_date: moment(moment().day(7)).format('YYYY-MM-DD')
                  });
                  this.props.handleWeekDate(moment().startOf('week').format('YYYY-MM-DD'));
                  this.props.getWeeklyAvgData({ 
                    start_date : moment().day(1).format('YYYY-MM-DD') + 'T00:00:00',
                    end_date : moment().day(7).format('YYYY-MM-DD') + 'T23:59:59',
                    field_office__uuid : this.state.selected_franchise
                  });
                  //Service statistics
                  // this.props.getServiceStatistics({
                  //   // search_param: '',
                  //   start_date: moment(moment().day(1)).format('YYYY-MM-DD'),
                  //   end_date: moment(moment().day(7)).format('YYYY-MM-DD')

                  // })
                  //Get Service Order
                  // this.getServiceOrder(moment(moment().day(1)).format('YYYY-MM-DDT00:00:00'), moment(moment().day(7)).format('YYYY-MM-DDT23:59:59'));
                  this.props.getFieldOfficeStaff({ 
                    start_date: moment(moment().day(1)).format('YYYY-MM-DD'),
                    field_office__uuid : this.props.selected_franchise,
                    ordering:'user__first_name'
                  });

                }

                let start_week_date = moment(e).startOf('week').format('DD');
                let end_week_date = moment(e).endOf('week').format('DD');
                let weekString = start_week_date + "-" + end_week_date;
                this.setState({
                  weekDate: weekString
                })
              }}
              suffixIcon={<DownOutlined />}
              format={"[Viewing Weekly (]MMMM " + this.state.weekDate + ",YYYY[)]"}
              className="swhite"
              allowClear={false}
            />
          </div>

          {/* <div className="gray_box teal_box">
            <div className="card-body">
              <div className="fitem-check check-header">
                {last_step ? <input type="checkbox" className="fitem-ck-input" id="RC_main" name="checkboxs" checked readOnly /> : ''}
                <label htmlFor="RC_main" className="fitem-ck-txt">Residential Cleaning</label>
              </div>
              <div className="check-body">
                <div className="d-flex justify-content-between ai-center mb-5">
                  <div className="fitem-check">
                    {last_step ? <input type="checkbox" className="fitem-ck-input" id="RC_sub_1"
                      name="twice-weekly"
                      value="twice-weekly"
                      onChange={(e) => { this.handleResidentialService(e) }}
                      checked /> : ''}
                    <label htmlFor="RC_sub_1" className="fitem-ck-txt m-0">Twice-Weekly Service</label>
                  </div>
                  <strong className="h6 m-0">{weekly_avg_data?.residential_cleaning?.twice_weekly}</strong>
                </div>


                <div className="d-flex justify-content-between ai-center mb-5">
                  <div className="fitem-check">
                    {last_step ? <input type="checkbox" className="fitem-ck-input" id="RC_sub_2" name="checkboxs" checked /> : ''}
                    <label htmlFor="RC_sub_2" className="fitem-ck-txt m-0">Weekly Service</label>
                  </div>
                  <strong className="h6 m-0">{weekly_avg_data?.residential_cleaning?.weekly}</strong>
                </div>

                <div className="d-flex justify-content-between ai-center mb-5">
                  <div className="fitem-check">
                    {last_step ? <input type="checkbox" className="fitem-ck-input" id="RC_sub_3" name="checkboxs" checked /> : ''}
                    <label htmlFor="RC_sub_3" className="fitem-ck-txt m-0">Every Other Week</label>
                  </div>
                  <strong className="h6 m-0">{weekly_avg_data?.residential_cleaning?.every_other_week}</strong>
                </div>

                <div className="d-flex justify-content-between ai-center mb-5">
                  <div className="fitem-check">
                    {last_step ? <input type="checkbox" className="fitem-ck-input" id="RC_sub_4" name="checkboxs" checked /> : ''}
                    <label htmlFor="RC_sub_4" className="fitem-ck-txt m-0"> Monthly</label>
                  </div>
                  <strong className="h6 m-0">{weekly_avg_data?.residential_cleaning?.monthly}</strong>
                </div>

                <div className="d-flex justify-content-between ai-center mb-5">
                  <div className="fitem-check">
                    {last_step ? <input type="checkbox" className="fitem-ck-input" id="RC_sub_5" name="checkboxs" /> : ''}
                    <label htmlFor="RC_sub_5" className="fitem-ck-txt m-0"> One Time Cleans</label>
                  </div>
                  <strong className="h6 m-0">{weekly_avg_data?.residential_cleaning?.one_time}</strong>
                </div>
              </div>
            </div>
          </div>
          <div className="gray_box yellow_box">
            <div className="card-body">
              <div className="fitem-check check-header">
                {last_step ? <input type="checkbox" className="fitem-ck-input" id="CC_main" name="checkboxs" checked readOnly /> : ''}
                <label htmlFor="CC_main" className="fitem-ck-txt">Commercial Cleaning</label>
              </div>
              <div className="check-body">
                <div className="d-flex justify-content-between ai-center mb-5">
                  <div className="fitem-check">
                    {last_step ? <input type="checkbox" className="fitem-ck-input" id="CC_sub_1" name="checkboxs" /> : ''}
                    <label htmlFor="CC_sub_1" className="fitem-ck-txt m-0">Pet Waste Station Cleaning</label>
                  </div>
                  <strong className="h6 m-0">{weekly_avg_data?.commercial_cleaning?.pet_wet_station_cleaning}</strong>
                </div>
                <div className="d-flex justify-content-between ai-center mb-5">
                  <div className="fitem-check">
                    {last_step ? <input type="checkbox" className="fitem-ck-input" id="CC_sub_2" name="checkboxs" /> : ''}
                    <label htmlFor="CC_sub_2" className="fitem-ck-txt m-0">Common Area Cleaning</label>
                  </div>
                  <strong className="h6 m-0">{weekly_avg_data?.commercial_cleaning?.common_area_cleaning}</strong>
                </div>
                <div className="d-flex justify-content-between ai-center mb-5">
                  <div className="fitem-check">
                    {last_step ? <input type="checkbox" className="fitem-ck-input" id="CC_sub_2" name="checkboxs" /> : ''}
                    <label htmlFor="CC_sub_2" className="fitem-ck-txt m-0">Installation Repair</label>
                  </div>
                  <strong className="h6 m-0">{weekly_avg_data?.commercial_cleaning?.installation_repairs}</strong>
                </div>
              </div>
            </div>
          </div>
          <div className="gray_box ltgreen_box">
            <div className="card-body">
              <div className="fitem-check check-header">
                {last_step ? <input type="checkbox" className="fitem-ck-input" id="PWS_main" name="checkboxs" checked readOnly /> : ''}
                <label htmlFor="PWS_main" className="fitem-ck-txt">PWS Installations</label>
              </div>
              <div className="check-body">
                <div className="d-flex justify-content-between ai-center mb-5">
                  <div className="fitem-check">
                    {last_step ? <input type="checkbox" className="fitem-ck-input" id="PWS_sub_1" name="checkboxs" /> : ''}
                    <label htmlFor="PWS_sub_1" className="fitem-ck-txt m-0">Pet Waste Station Installations</label>
                  </div>
                  <strong className="h6 m-0">{weekly_avg_data?.pws_installation}</strong>
                </div>
              </div>
            </div>
          </div>
          */}

          <div className="gray_box teal_box">
            <div className="card-body">
              <div className="fitem-check check-header">
                {last_step ? <input type="checkbox"
                  className="fitem-ck-input"
                  id="RC_main"
                  name="check_all"
                  value="check_all"
                  checked={this.state.is_res_sub_checked_all}
                  onChange={(e) => { this.handleCheckedResidentialServices(e) }}
                /> : ''}
                <label htmlFor="RC_main" className="fitem-ck-txt">Residential Cleaning</label>
              </div>
              <div className="check-body">
                {this.state.res_sub_services?.map((item, i) => {
                  return <div key={i}>
                    <div className="d-flex justify-content-between ai-center mb-5">
                      <div className="fitem-check">
                        {last_step ?
                          <input type="checkbox" className="fitem-ck-input"
                            name={item.name}
                            checked={item.is_checked}
                            id={`checkbox${item.id}`}
                            onChange={(e) => { this.handleCheckedResidentialServices(e) }}
                          /> : ''}
                        <label htmlFor={`checkbox${item.id}`} className="fitem-ck-txt m-0">{item.display_name}</label>
                      </div>
                      <strong className="h6 m-0">{item.value}</strong>
                    </div>
                  </div>
                })}
              </div>

            </div>
          </div>

          <div className="gray_box yellow_box">
            <div className="card-body">
              <div className="fitem-check check-header">
                {last_step ? <input type="checkbox" className="fitem-ck-input"
                  id="CC_main"
                  name="check_all"
                  value="check_all"
                  checked={this.state.is_commercial_sub_checked_all}
                  onChange={(e) => { this.handleCheckedCommercialServices(e) }}
                /> : ''}
                <label htmlFor="CC_main" className="fitem-ck-txt">Commercial Cleaning</label>
              </div>
              <div className="check-body">
                {this.state.commercial_sub_servcies?.map((item, i) => {
                  return <div key={i}>
                    <div className="d-flex justify-content-between ai-center mb-5">
                      <div className="fitem-check">
                        {last_step ?
                          <input type="checkbox" className="fitem-ck-input"
                            name={item.name}
                            checked={item.is_checked}
                            id={`checkbox${item.id}`}
                            onChange={(e) => { this.handleCheckedCommercialServices(e) }}
                          /> : ''}
                        <label htmlFor={`checkbox${item.id}`} className="fitem-ck-txt m-0">{item.display_name}</label>
                      </div>
                      <strong className="h6 m-0">{item.value}</strong>
                    </div>
                  </div>
                })}
              </div>

            </div>
          </div>

          <div className="gray_box ltgreen_box">
            <div className="card-body">
              <div className="fitem-check check-header">
                {last_step ? <input type="checkbox" className="fitem-ck-input"
                  id="PWS_main"
                  name="check_all"
                  value="check_all"
                  checked={this.state.is_pws_sub_checked_all}
                  onChange={(e) => { this.handleCheckedPWsServices(e) }}
                /> : ''}
                <label htmlFor="PWS_main" className="fitem-ck-txt">PWS Installations</label>
              </div>
              <div className="check-body">
                {this.state.pws_sub_services?.map((item, i) => {
                  return <div key={i}>
                    <div className="d-flex justify-content-between ai-center mb-5">
                      <div className="fitem-check">
                        {last_step ?
                          <input type="checkbox" className="fitem-ck-input"
                            name={item.name}
                            checked={item.is_checked}
                            id={`checkbox${item.id}`}
                            onChange={(e) => { this.handleCheckedPWsServices(e) }}
                          /> : ''}
                        <label htmlFor={`checkbox${item.id}`} className="fitem-ck-txt m-0">{item.display_name}</label>
                      </div>
                      <strong className="h6 m-0">{item.value}</strong>
                    </div>
                  </div>
                })}
              </div>

            </div>
          </div>

          {last_step && this.props.isWeekSetup ?
            <div className="mb-10 field_search_bar select-multiple">
              <Select
                placeholder="Search Technician"
                // filterOption={true}
                // onSelect={(value, option) => {
                //   this.props.handleSelectedTechnician(option.key);
                // }}
                onChange={(value) => {
                  if (value === '' || value === undefined) {
                    const selected_value = "";
                    this.props.handleSelectedTechnician(selected_value);
                  } 
                  else {
                    this.props.handleSelectedTechnician(value);
                  }
                }}
                showSearch
                filterOption={(input,option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }

                // style={{ 'width': '150px' }}
                // className="multi_select_technician"
                allowClear={true}
                // value={this.props.selected_resource}
                // labelInValue
                // optionLabelProp="label"
                mode="multiple"
              >
                {this.state.technicians.map((item) => (
                  <Option key={item.technician_uuid} label={item.technician_name} value={item.technician_uuid} >{item.title}</Option>
                ))}
              </Select>
              <div className="fitem-ricon"><i className="las la-search"></i> </div>
            </div>

            : ''
          }
          {last_step && !this.props.isWeekSetup ?
            <div className="mb-20 field_search_bar ">
              <input type="text"
                // onChange={(e) => { console.log(e) }}
                onChange={(e) => { this.props.handleSearchValue(e.target.value) }}
                placeholder="Search for Customers"
              />
              <div className="fitem-ricon"><i className="las la-search"></i> </div>
            </div>
            : ''}
          {last_step && this.props.isWeekSetup ?
            <React.Fragment>
              <div className="mb-10 side-status-block red-status d-flex justify-content-start ai-center">
                <span className="number">{weekly_service_statistics?.missed_services}</span>
                <span className="txt">MISSED SERVICES</span>
              </div>
              <div className="mb-10 side-status-block grey-status d-flex justify-content-start ai-center">
                <span className="number">{weekly_service_statistics?.awaiting_completion}</span>
                <span className="txt">AWAITING COMPLETION</span>
              </div>
              <div className="mb-10 side-status-block green-status d-flex justify-content-start ai-center">
                <span className="number">{weekly_service_statistics?.completed_services}</span>
                <span className="txt">COMPLETE</span>
              </div>
              {/* <div className="mt-5">
                <AutoComplete
                  placeholder="Search Technician"
                  filterOption={true}
                  onSelect={(value,option) => {
                    this.props.handleSelectedTechnician(option.key);
                  }}
                  onChange={(value) => {
                    console.log("Value : ",value)
                    if(value === '') {
                      this.props.handleSelectedTechnician(value);
                    }
                  }}
                >
                  {this.state.technicians.map((item) => (
                    <Option key={item.technician_uuid} value={item.title} />
                  ))}
                </AutoComplete>
              </div> */}
            </React.Fragment>
            : ''}

        </div>
        {/* <div className="d-flex justify-content-end w-100">
          {current !== 0 ? <button className="btn btn-brand btn-bdr"
            onClick={() => {
              if (this.props.isWeekSetup) {
                this.props.handelRerunOptimization(!this.props.is_rerun_optimization)
              } else {
                // this.props.handelRerunOptimization(false)
                sessionStorage.removeItem('residentail_selected_row_keys');
                sessionStorage.removeItem('intial_selected_row_keys');
                sessionStorage.removeItem('commercial_selected_row_keys');
                sessionStorage.removeItem('install_selected_row_keys');
                this.props.previousStep(this.props.current === 1 ? 0 : this.props.current === 2 ? 1 : 0);
              }
            }}
          >{this.props.isWeekSetup ? 'Rerun Optimization' : 'Previous'}</button> : ''}
          {
            current === 2 ?
              <button onClick={() => {
                if (this.props.isWeekSetup) {
                  this.props.history.push('/field_tech/eod_report')
                }
                else {
                  this.setState({ loader: true });
                  this.props.getServiceStatistics({
                    start_date: `${this.state.start_date}T00:00:00`,
                    end_date: `${this.state.end_date}T23:59:59`,
                    field_office__uuid: this.state.selected_franchise
                  })
                  this.props.handleCompeleteWeekSetup(true)
                }
                // 
              }} className="btn btn-primary btn-resize">{this.props.isWeekSetup ? "Submit EOD Report" : "Complete Weekly Setup"}</button>
              :<> {this.props.current !== 0 && 
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    this.props.nextStep(this.props.current === 0 ? 1 : this.props.current === 1 ? 2 : 0)
                  }}>
                Next Step</button>}</>
          }


        </div> */}
        {loader ? <Loader /> : ''}
      </aside>
    );
  }
}

export default Aside;